import { InjectionToken } from '@angular/core';

import { IAppConfig } from './iapp.config';

export let APP_CONFIG = new InjectionToken('app.config');

export const AppConfig: IAppConfig = {
  app: 'Ranseps',
  routes: {
    login: 'login',
    home: 'home',
    about: 'about',
    ranseps: 'ranseps',
    files: 'files',
    contact: 'contact',
    error404: '404',
    error500: '500'
  },
  endpoints: {
    api: 'http://ranseps.crg.es/api/',
  }
};
